import { Grid, Tooltip, Chip } from "@mui/material";

import ScopeThreeCategorySelect from "./ScopeThreeCategorySelect";

import OpenAiVendorCategorization from "./OpenAiVendorCategorization";

const SpendBasedVendorInputs = ({
  editVendor,
  scopeThreeCategory,
  naicsTitle,
  disabled,
  naicsDisabled = false,
  naicsDisabledTooltip = "",
  ...otherProps
}) => (
  <>
    {naicsDisabled ? (
      <Grid item alignSelf="center">
        <Tooltip title={naicsDisabledTooltip}>
          <Chip label={naicsTitle || "No category set"} />
        </Tooltip>
      </Grid>
    ) : (
      <OpenAiVendorCategorization
        editVendor={editVendor}
        disabled={disabled}
        naicsTitle={naicsTitle}
        {...otherProps}
      />
    )}
    <Grid item>
      <ScopeThreeCategorySelect
        scopeThreeCategory={scopeThreeCategory}
        setScopeThreeCategory={editVendor("scopeThreeCategory")}
        disabled={disabled}
      />
    </Grid>
  </>
);
export default SpendBasedVendorInputs;
